import { Component, OnInit } from '@angular/core';
import { InvoiceService } from 'app/shared/services/invoice.service';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { ItemService} from 'app/shared/services/item.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DecimalPipe } from '@angular/common';
import { NbThemeService } from '@nebular/theme';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators'

@Component({
  selector: 'ngx-item-sales-report',
  templateUrl: './item-sales-report.component.html',
  styleUrls: ['./item-sales-report.component.scss']
})
export class ItemSalesReportComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>

  fromDate : Date;
  toDate : Date;
  itemCode : string;
  paymentType : string = null;
  salesType : string =null;
  isDark: boolean = false;

  myControl = new FormControl();
  filteredItemList: Observable<any[]>;
  itemList : any[];


  SALES_TYPE =[
    {value: 'Company-Outlet'},
    {value: 'Online'},
    {value: 'Dealer'},
    {value: 'Distributor'},
    {value: 'Export'},
  ];

  PMT_TYPE =[
    {value: 'Cash'},
    {value: 'Credit'},
  ];


  invoiceLst : any[]=[];
  filteredInvoiceList : any[]=[];


  constructor(
              private invoiceService : InvoiceService, 
              private router : Router, 
              private themeService: NbThemeService,
              private itemService : ItemService,
              private decimalPipe: DecimalPipe
             )
              {
                this.datepickerConfig = Object.assign({},
                {   
                  showWeekNumbers:false,
                  dateInputFormat : 'YYYY-MM-DD'
                });

              }

    ngOnInit() {
      this.getAllInvoices();  
      this.getItemList();
      this.autoComplete();

      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
         });
    }

    autoComplete(){
      this. filteredItemList = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterCustomer(value))
      ); 
  }

  private _filterCustomer(itemCode: string): any[] {
    if(itemCode){
       const filterValue = itemCode.toLowerCase();
       return this.itemList.filter(option => option.ItemCode.toLowerCase().indexOf(filterValue) === 0);
    }
  }


 
    getAllInvoices(){
    this.invoiceService.getAllQtySales()
     .subscribe(
        (data) => {
                  this.invoiceLst = data.filter((el)=>{
                    return el.Type ==="Bar Invoice";
                  });   ;
                  this.filteredInvoiceList =  this.invoiceLst ;                           
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });          
     }

     getItemList(){
      this.itemService.getAll()
       .subscribe(
          (data) => {
                    this.itemList = data;           
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
         
       }
    

     getTotalQty(){
      return this.filteredInvoiceList.map(data=>data.Qty).reduce((acc,value)=>acc + +value,0);
     }
     getTotalAmount(){
      return this.filteredInvoiceList.map(data=>data.Amount).reduce((acc,value)=>acc + +value,0);
     }
    

     viewBtnClicked(){
      var startDate =moment(this.fromDate).format("YYYY-MM-DD");
      var endDate =moment(this.toDate).format("YYYY-MM-DD");

      if(this.fromDate && this.toDate){
        this.filteredInvoiceList = this.invoiceLst.filter(data => {
          var expDate = moment(data.InvoiceDate).format("YYYY-MM-DD");              
           return moment(expDate).isBetween(startDate, endDate,undefined,'[]'); 
           });

      }
        
        
    }


     clearBtnClicked(){
      this.fromDate = null;
      this.toDate = null;
      this.paymentType= null;
      this.salesType= null;
      this.itemCode= '';
      this.filteredInvoiceList =  this.invoiceLst ; 
     }

     savePDF(action){

      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'landscape',

        content: [   
          { text: 'Bar Sales Report', style: 'reportHeader' }, 
          { text: (this.fromDate && this.toDate) ? `${moment(this.fromDate).format("YYYY-MM-DD")} To ${moment(this.toDate).format("YYYY-MM-DD")}` : '',alignment: 'center',margin: [0, 3] }, 
           
                     
          {  
            table: {  
                headerRows: 1,  
                widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto','auto', 'auto'],  
                body: [  
                  ['InvoiceDate','InvoiceNo', 'Customer','CreatedBy', 'ItemCode','UnitPrice', 'Qty','Amount',],
                  ...this.filteredInvoiceList.map(p => ([moment(p.InvoiceDate).format("YYYY-MM-DD"), p.InvoiceNo, p.GuestName, p.CreatedBy ,p.ItemCode ,{ text: this.transformNumberFormat(p.UnitPrice),alignment: 'right' }, { text: this.transformNumberFormat(p.Qty),alignment: 'right' },{ text: this.transformNumberFormat(p.Amount),alignment: 'right' }])),  
                  [ { text: 'Total', bold: true, colSpan: 6 },{},{},{},{},{},{ text :  this.transformNumberFormat(this.getTotalQty()),alignment: 'right', bold : true }, { text :  this.transformNumberFormat(this.getTotalAmount()),alignment: 'right', bold : true } ]  
                ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 10],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }

     exportexcel(): void 
     {
        /* table id is passed over here */   
        let element = document.getElementById('salesReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
        /* save to file */
        XLSX.writeFile(wb, 'Sales Report.xlsx');
       
     }

     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
     }

}
